import * as Yup from 'yup';
import { isValidPhoneNumber } from 'mui-tel-input';

import DeliveryAddressType from '@shared/enums/DeliveryAddressType';

const INCORRECT_NUMBER_FORMAT = 'Incorrect number format';
const INCORRECT_WAREHOUSE_FORMAT = 'Invalid format. Expected: "City NP №123" or "City НП №123"';

const NOVA_POSHTA_WAREHOUSE_REGEX =
  /^[\p{L}.\s,-]+\s+(?:(?:NP|НП|відділення|Відділення)\s*)?[№#]?\s*\d*$/u;

const fieldsSchema = {
  deliveryAddress: Yup.object().shape({
    cityAndWarehouseNumber: Yup.string().test(
      'cityAndWarehouseNumber',
      INCORRECT_WAREHOUSE_FORMAT,
      (value, context) => {
        if (context.parent.type !== DeliveryAddressType['Nova Poshta']) return true;
        if (!value) return false;

        return NOVA_POSHTA_WAREHOUSE_REGEX.test(value);
      }
    ),
    phoneNumber: Yup.string().test('phoneNumber', INCORRECT_NUMBER_FORMAT, (value, context) => {
      if (context.parent.type !== DeliveryAddressType['Nova Poshta']) return true;
      if (!value) return false;

      return isValidPhoneNumber(value);
    }),
  }),
};

export const validationSchema = Yup.object().shape(fieldsSchema);
